interface IBuildAddressLine2Params {
  city: string;
  state: string;
}

export const buildAddressLine2 = ({ city, state }: IBuildAddressLine2Params): string => `${city}, ${state}`;
